import React from "react";

const field =
  "block w-full rounded-lg border border-border bg-background px-3 py-2 " +
  "text-foreground placeholder-muted-foreground focus:outline-none " +
  "focus:ring-2 focus:ring-brand/40 focus:border-brand/50";

export function RoutingChangeForm({ formData, setFormData }) {
  return (
    <section className="space-y-4">
      <h3 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground">
        Routing Change
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <label className="space-y-1">
          <span className="text-sm font-medium">Before *</span>
          <input
            type="text"
            required
            value={formData.change.before}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                change: { ...prev.change, before: e.target.value },
              }))
            }
            className={field}
            placeholder="Current routing configuration"
          />
        </label>
        <label className="space-y-1">
          <span className="text-sm font-medium">After *</span>
          <input
            type="text"
            required
            value={formData.change.after}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                change: { ...prev.change, after: e.target.value },
              }))
            }
            className={field}
            placeholder="New routing configuration"
          />
        </label>
      </div>
      <label className="space-y-1">
        <span className="text-sm font-medium">Description *</span>
        <textarea
          required
          rows={3}
          value={formData.change.description}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              change: { ...prev.change, description: e.target.value },
            }))
          }
          className={`${field} min-h-[96px]`}
          placeholder="Describe the change and the rationale"
        />
      </label>
    </section>
  );
}
